import Svg from 'components/utilities/svg'

const OpenInIcon = ({ ...props }) => (
  <Svg viewBox="0 0 8 8" {...props}>
    <title>Open In Icon</title>
    <path d="M1.11323 7.83466C0.850869 7.83466 0.627293 7.74226 0.442501 7.55747C0.257709 7.37268 0.165314 7.1491 0.165314 6.88674V1.1132C0.165314 0.850839 0.257709 0.627262 0.442501 0.442471C0.627293 0.257679 0.850869 0.165283 1.11323 0.165283H4V1.1132H1.11323V6.88674H6.88677V3.99997H7.83469V6.88674C7.83469 7.1491 7.74229 7.37268 7.5575 7.55747C7.37271 7.74226 7.14913 7.83466 6.88677 7.83466H1.11323ZM3.11886 5.54164L2.45833 4.88112L6.22625 1.1132H4.83333V0.165283H7.83469V3.16664H6.88677V1.77372L3.11886 5.54164Z" />
  </Svg>
)

OpenInIcon.displayName = 'Open In'

export default OpenInIcon
